<template>
    <div class="financeApplication__form">
        <ValidationObserver ref="observer">
            <div :class="classNames">
                <ValidationProvider
                    name="sort code"
                    :rules="sortCodeValidationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        id="bankSortCode"
                        label="Sort Code"
                        :error-message="errors[0]"
                    >
                        <FinanceApplicationText
                            id="bankSortCode"
                            placeholder="12-34-56"
                            v-model="bankSortCode"
                            ref="sortCode"
                        />
                    </FinanceApplicationRow>
                </ValidationProvider>

                <ValidationProvider
                    name="account number"
                    :rules="accountNumberValidationRules"
                    v-slot="{ errors }"
                    slim
                >
                    <FinanceApplicationRow
                        id="bankAccountNumber"
                        label="Account Number"
                        :error-message="errors[0]"
                    >
                        <FinanceApplicationText
                            type="number"
                            id="bankAccountNumber"
                            placeholder="87654321"
                            v-model="bankAccountNumber"
                        />
                    </FinanceApplicationRow>
                </ValidationProvider>
            </div>
        </ValidationObserver>

        <div class="financeApplication__additionalText">
            <strong>Please note.</strong> We ONLY use these details to provide you with a quote.
        </div>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Inputmask from 'inputmask'
import FinanceApplicationText from './FinanceApplicationText.vue'
import FinanceApplicationRow from './FinanceApplicationRow.vue'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        FinanceApplicationRow,
        FinanceApplicationText,
    },
    props: {
        initialValues: {
            type: Object,
            default: () => {}
        },
        windowWidth: {
            type: Number
        }
    },
    data() {
        return {
            bankSortCode: this.initialValues.bankSortCode,
            bankAccountNumber: this.initialValues.bankAccountNumber,
            mask: null
        }
    },
    mounted() {
        const sortCodeInput = this.$refs.sortCode.$el.querySelector('input#bankSortCode')
        Inputmask({
            mask: '99-99-99'
        }).mask(sortCodeInput);
    },
    methods: {
        async onChange({ key, value }) {
            this.$emit('change', { key, value })

            const valid = await this.$refs.observer.validate()
            this.$emit('validate', { key: 'bankDetails', valid })
        }
    },
    computed: {
        classNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 670) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        sortCodeValidationRules() {
            return {
                required: true,
                regex: /^[0-9]{2}[-][0-9]{2}[-][0-9]{2}$/
            }
        },
        accountNumberValidationRules() {
            return {
                required: true,
                min: 8,
                max: 8
            }
        }
    },
    watch: {
        bankSortCode(value) {
            this.onChange({
                key: 'bankSortCode',
                value
            })
        },
        bankAccountNumber(value) {
            this.onChange({
                key: 'bankAccountNumber',
                value
            })
        },
    }
}
</script>